import { render, staticRenderFns } from "./verifyEmail.vue?vue&type=template&id=a323557c&scoped=true&"
import script from "./verifyEmail.vue?vue&type=script&lang=js&"
export * from "./verifyEmail.vue?vue&type=script&lang=js&"
import style0 from "./verifyEmail.vue?vue&type=style&index=0&id=a323557c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a323557c",
  null
  
)

export default component.exports